import CheckRoundedIcon from "@mui/icons-material/CheckRounded";
import { Stack, Typography } from "@mui/material";

export const Copied = () => {
  return (
    <Stack direction="row" sx={{ flexGrow: 1, alignItems: "center", gap: 0.5 }}>
      <CheckRoundedIcon color="success" />
      <Typography sx={{ color: "success.main" }}>The widget has been successfully copied</Typography>
    </Stack>
  );
};
